import GenericDB from './generic-db'

export default class ShareLinksGoogleDB extends GenericDB {
  constructor() {
    super(`shareLinksGoogle`)
  }
  // Here you can extend ShareLinksGoogleDB with custom methods
}
